import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { mapStateToProps } from '../../../redux/reducers';
import moment from "moment";
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useForm, useFieldArray } from 'react-hook-form';
import { Row, Col, Form } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';
import SelectDropdown from '../../common/selectdropdown-component';
import '../../../styles/home.scss';
import DatePickerViews from '../../common/components/datePicker';
import TimePickerViews from '../../common/components/timePicker';
import * as actionTypes from '../../../redux/actionTypes/csaSignup';
import { costWeightChange } from '../../../utils/globalMethods';
import dayjs from "dayjs";
// eslint-disable-next-line no-unused-vars
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { stateFromHTML } from 'draft-js-import-html';



const ShareAddEditComponent = (props) => {
    
    const {submitShareData,onEdit,row,vendorId,getSnapCsaLocationList} = props;

    const [addressList, setAddressList] = useState([]);
    const [daysList, setDaysList] = useState([]);
    const [selectedDay, setSelectedDay] = useState([]);
    const [units, setUnits] = useState(onEdit && row.shareQtyUnit && row.shareQtyUnit == "lbs" ? 'Pounds' :'Units');
    const [startDate, setStartDate] = useState(onEdit ? dayjs(row.startDate).startOf('month').format("YYYY-MM-DD") : (dayjs().date() > 26 ? dayjs().startOf('month').add(2, 'month').format('YYYY-MM-DD') : dayjs().startOf('month').add(1, 'month').format('YYYY-MM-DD')));
    const [endDate, setEndDate] = useState(onEdit && dayjs(row.endDate).endOf('month').format("YYYY-MM-DD") || dayjs().add(2, 'month').endOf('month').format('YYYY-MM-DD'));
    const [selectedAddress, setSelectedAddress] = useState([]);
    // eslint-disable-next-line no-unused-vars 
    const [currentSelection, setCurrentSelection] = useState({});
    const [selectedLocation, setSelectedLocation] = useState(() => {
        if (onEdit && row.dlvryFlg === "Y" && row.pickupDetails && row.pickupDetails.length > 0) {
            return ["delivery", "pickup"];  // Return both when both conditions are met
        } else if (onEdit && row.dlvryFlg === "Y") {
            return ["delivery"];
        } else if (onEdit && row.pickupDetails && row.pickupDetails.length > 0) {
            return ["pickup"];
        } else {
            return [];
        }
    });

    const [deletedPickupDetails, setDeletedPickupDetails] = useState([]);

    // const [deliveryLocation, setDeliveryLocation] = useState(onEdit && row.dlvryFlg || "");
    const initialEditorState = onEdit ? 
    EditorState.createWithContent(stateFromHTML(row.dsc || '')) : 
    EditorState.createEmpty();
    // eslint-disable-next-line no-unused-vars
    const [editorState, setEditorState] = useState(initialEditorState);


    

    let initial = onEdit? {
        nam: row.nam,
        startDate: row.startDate,
        endDate: row.endDate,
        shareCost: row.shareCost,
        pickupDetails:row.pickupDetails,
        shareQty: row.shareQty,
        shareQtyUnit: row.shareQtyUnit,
        dlvryFlg:row.dlvryFlg,
        range: row.range,
        dsc:row.dsc,
        id: row.id,
        location:selectedLocation
    } : {
        nam: "",
        startDate: startDate, 
        endDate: endDate,
        shareCost: "",
        pickupDetails:  selectedLocation.includes("pickup")
        ? [
            {
                address: "",
                day: "",
                openTime: "12:00 AM",
                closeTime: "12:00 AM",
            },
        ]
        : [],
        // [{
        //     address: "",
        //     day: "",
        //     openTime: "12:00 AM",
        //     closeTime:"12:00 AM"
        // }],
        dlvryFlg:"",
        shareQty:"",
        range: "",
        dsc:"",
        location: selectedLocation
    };
    const [formValue] = useState(initial);

    useEffect(() => {
        const payload = {
            "vendorId":vendorId,
            "from": 0,
            "size": 1000,
            "all":true
        }
        getSnapCsaLocationList(payload);
    }, []);

    useEffect(() => {
        const { list } = props.csaSignup.allSnapCsaLocationList;
        let data = []
        list.forEach(ele => {
            let address = ele.addressLine1 ? ele.addressLine1+", " : "";
            address += ele.addressLine2 ? ele.addressLine2+", " : "";
            address += ele.city ? ele.city+", " : "";
            address += ele.state ? ele.state+", " : "";
            address += ele.zipcode ? ele.zipcode : "";
            data.push({name:ele.addressId, vendorId:vendorId, values:address, isActive:1});
        });
        setAddressList(data);
    }, [props.csaSignup.allSnapCsaLocationList]);

    useEffect(() => {
        const list = props.mapdata.days;
        let data = []
        list.forEach(ele => {
            data.push({name:ele.weekDay, values:ele.values, isActive:1});
        });
        setDaysList(data);
    }, [props.mapdata.days]);

    
    const {
        register,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
        getValues,
        clearErrors,
        // trigger
    } = useForm({
        defaultValues: formValue
    });

    useEffect(() => {
        if(onEdit){
            let addressData = [];
            let daysData = [];
            let constDayList = props.mapdata.days;
            row.pickupDetails.map(ele => {
                let address = ele.address1 ? ele.address1+", " : "";
                address += ele.address2 ? ele.address2+", " : "";
                address += ele.city ? ele.city+", " : "";
                address += ele.state ? ele.state+", " : "";
                address += ele.zipcode ? ele.zipcode : "";
                addressData.push({name: ele.addressId, values: address})
                daysData.push({name: ele.day, values: constDayList.filter(item => item.weekDay == ele.day)[0].values });
            })
            setSelectedAddress(addressData);
            setSelectedDay(daysData);
        }
    }, [row,props.mapdata.days]);

    const {
        fields,
        append,
        remove
    } = useFieldArray({
        control,
        name: "pickupDetails"
    });

    const onSubmit = (data) => {
        if(Object.keys(errors).length === 0){
            let payload = Object.assign(data, {
                "vendorId": vendorId,
                "contactInfo":"",
                "shareQtyUnit":units=="Units" ? "qty" : "lbs",
                "vendorType": "CSAVDR",
                // "dlvryFlg":deliveryLocation
            });
            payload.shareQty = parseFloat(payload.shareQty);
            payload.shareCost = parseFloat(payload.shareCost);
            if(onEdit){
                payload.isStatusUpdate="N";
                payload.pickupFlg="Y";
                payload.range= selectedLocation.includes("delivery") ? data.range : "";
            }
            submitShareData(payload);
        }
    };

    useEffect(() => {
        if (selectedLocation.includes("delivery")) {
            setValue("dlvryFlg", "Y");  
        } else {
            setValue("dlvryFlg", "N"); 
        }
    }, [selectedLocation, setValue]);

// eslint-disable-next-line no-unused-vars
  const onEditorStateChange = (newState) => {
    setEditorState(newState);
    const htmlContent = draftToHtml(convertToRaw(newState.getCurrentContent()));
    setValue('dsc', htmlContent, { shouldValidate: true });
  };
  return (

    <div className="form-block addShareInfo" role="main">
        <Form noValidate onSubmit={handleSubmit(onSubmit)} auto>
            <Row>
                <Col xs={12}>
                    {Object.keys(errors).length > 0 && Object.keys(errors)[0] != "pickupDetails" &&  <Form.Text className="dh-txt-danger" role="alert" aria-live="assertive">
                        <b><i className="fa fa fa-info-circle ml-2" aria-hidden="true"></i> {errors[Object.keys(errors)[0]].message} </b>
                    </Form.Text>}
                    <Form.Group as={Col}>
                        <Form.Label className="smallTitle">Share Name <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                        <Form.Control type="text" {...register("nam", { required: "Please enter Share Name",})}
                            maxLength={"100"} aria-label='sharename' />
                    </Form.Group>
                    <Row className={'mb-2'} xs={12}>
                        <Col xs={12} md={4}>
                            <Form.Group as={Col}>
                                <Form.Label className="smallTitle">Start Duration <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                <DatePickerViews
                                    handleChange={(newValue) => {
                                        setValue("startDate",dayjs(newValue).startOf('month').format("YYYY-MM-DD"))
                                        setStartDate(dayjs(newValue).startOf('month').format("YYYY-MM-DD"))
                                    }}
                                    value={startDate}
                                    
                                    minDate={dayjs().date() > 26 ? dayjs().startOf('month').add(2, 'month') : dayjs().startOf('month').add(1, 'month')}
                                    maxDate={dayjs().startOf('month').add(1, 'year')}
                                    {...register("startDate", { required: "Please enter Start Date" })}
              
                                    // disabled={dayjs().isBefore(dayjs(startDate), 'month')}  dayjs().date() > 26 ? dayjs().add(2, 'month') : 
                                                              
                                     />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={4}>
                            <Form.Group as={Col}>
                                <Form.Label className="smallTitle">End Duration<span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                <DatePickerViews
                                    handleChange={(newValue) => {
                                        setValue("endDate",dayjs(newValue).endOf('month').format("YYYY-MM-DD"))
                                        setEndDate(dayjs(newValue).endOf('month').format("YYYY-MM-DD"))
                                        console.log("end date, ",endDate)
                                    }}
                                    value={endDate}
                                    minDate={dayjs(startDate).endOf('month')} 
                                    maxDate={dayjs(startDate).endOf('month').add(11, 'month')}

                                    {...register("endDate", { required: "Please enter End Date",
                                    validate:{
                                        notBeforeStart: (value) => {
                                            if (dayjs(value).isBefore(startDate)) {
                                                return "End date must be greater than the start date.";
                                            }
                                            if (dayjs(value).isAfter(dayjs(startDate).add(1, 'year'))) {
                                                return "End date must be within one year from the start date.";
                                            }
                                            return true;
                                        }
                                     }
                                    })}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={4}>
                            <Form.Group as={Col} controlId="formUserFirstName">
                                <Form.Label className="smallTitle">Monthly Cost<span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                <InputGroup>
                                    <InputGroup.Text id="btnGroupAddon"><i className="fa fa-usd"><span className='sr-only'>dollar</span></i></InputGroup.Text>
                                    <Form.Control
                                        {...register("shareCost", { required: "Please enter Monthly Cost"})}
                                        onKeyDown={(e) => {
                                            const value = e.target.value;
                                            const maxLength = 15; 
                                            const decimalIndex = value.indexOf('.');
                                            const decimalLength = decimalIndex === -1 ? 0 : value.length - decimalIndex - 1;
                                            if (decimalIndex !== -1 && e.key === '.') {
                                                e.preventDefault();
                                            }
                                            if ((value.replace('.', '').length >= maxLength || decimalLength >= 2) && e.key !== 'Backspace' && e.key !== '.') {
                                                e.preventDefault(); 
                                            }
                                            if (decimalIndex === -1 && value.length >= 12 && e.key !== 'Backspace' && e.key !== '.') {
                                                e.preventDefault(); 
                                            }
                                        }}
                                        onChange={(e) =>{
                                            costWeightChange(e);setValue("shareCost", e.target.value, { shouldValidate: true });}}
                                        placeholder=" "
                                        aria-label="Monthly cost textbox" 
                                        // aria-describedby="btnGroupAddon"
                                        onDrop={(e)=>e.preventDefault()}
                                        onPaste={(e)=>e.preventDefault()}
                                        autoComplete='off'
                                        
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                    <Col md={6} className="d-flex justify-content-center align-items-center">
                    <Form.Group as={Row}>
                        <Form.Label className="smallTitle">Pickup Location/Delivery Location *</Form.Label>
                        <Col>
                            <Form.Check
                                style={{ border: 'none', width: '160px',}}
                                inline
                                type="checkbox"
                               label="Pickup Location"
                               aria-label="pickup Location"
                                value="pickup"
                                {...register("location", { required: "Please enter pickup/delivery location" })}
                                checked={selectedLocation.includes("pickup")}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    let updatedValues;
                            
                                    if (selectedLocation.includes(value)) {
                                        // When unchecking the checkbox:
                                        updatedValues = selectedLocation.filter((item) => item !== value);
                                        if (fields.length > 0) {
                                            const updatedFields = fields.map((field, index) => ({
                                                ...field,
                                                addressId: getValues(`pickupDetails.${index}.addressId`) || field.addressId, 
                                                address: getValues(`pickupDetails.${index}.address`) || field.address, 
                                                day: getValues(`pickupDetails.${index}.day`) || field.day,
                                                openTime: getValues(`pickupDetails.${index}.openTime`) || field.openTime, 
                                                closeTime: getValues(`pickupDetails.${index}.closeTime`) || field.closeTime
                                            }));
                                            setDeletedPickupDetails(updatedFields); // Save updated fields before removal
                                        }
                                        // Remove all fields
                                        remove();
                                        // setValue("pickupDetails", [], { shouldValidate: false }); // Reset pickupDetails
                                        setSelectedLocation(updatedValues);
                                        setValue("location", updatedValues, { shouldValidate: true });
                                        clearErrors("location"); 
                                        // setTimeout(() => {
                                        //     clearErrors("pickupDetails");
                                        //     trigger("pickupDetails"); // Re-trigger validation to reflect the removal
                                        // }, 200);
                                    } else {
                                        // When checking the checkbox:
                                        updatedValues = [...selectedLocation, value];
                                        setSelectedLocation(updatedValues);
                                        setValue("location", updatedValues, { shouldValidate: true });
                                        clearErrors("location"); 
                            
                                        // Re-add deleted fields if any
                                        if (deletedPickupDetails.length > 0) {
                                            deletedPickupDetails.forEach((detail, index) => {
                                                append(detail);
                                                // Object.keys(detail).forEach((key) => {
                                                //     setTimeout(() => {
                                                //         setValue(`pickupDetails.${index}.${key}`, detail[key], { shouldValidate: true });
                                                //     }, 100);
                                                // });
                                            });
                                            // setTimeout(() => {
                                            //     clearErrors("pickupDetails");
                                            //     trigger("pickupDetails"); // Trigger validation for pickupDetails
                                            // }, 200);
                                        } else {
                                            // If no previous fields, add a new one
                                            if (fields.length === 0) {
                                                append({ address: "", day: "", openTime: "12:00 AM", closeTime: "12:00 AM" });
                                            }
                                        }
                                    }
                                }}
                            />
                            <Form.Check
                                style={{ border: 'none', width: '169px'}}
                                inline
                                type="checkbox"
                                label="Delivery Location"
                                aria-label="DeliveryLocation"
                                value="delivery"
                                {...register("location", { required: "Please enter pickup/delivery location" })}
                                checked={selectedLocation.includes("delivery")}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const updatedValues = selectedLocation.includes(value)
                                        ? selectedLocation.filter((item) => item !== value)
                                        : [...selectedLocation, value];
                        
                                    setSelectedLocation(updatedValues);
                                    setValue("location", updatedValues); 
                                    clearErrors("location"); 
                                }}                      
                            />
                        </Col>
                    </Form.Group>
                    </Col>
                    <Col>
                            <Form.Group as={Col} controlId="formUserFirstName">
                                <Form.Label className="smallTitle">Weight/Amount of Goods <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                <InputGroup>
                                    <Form.Control type="text" 
                                        {...register("shareQty", { required: "Please enter Weight/Amount of goods"})} 
                                        onKeyDown={(e) => {
                                            const value = e.target.value;
                                            const maxLength = 8; 
                                            const decimalIndex = value.indexOf('.');
                                            const decimalLength = decimalIndex === -1 ? 0 : value.length - decimalIndex - 1;
                                            if (decimalIndex !== -1 && e.key === '.') {
                                                e.preventDefault();
                                            }
                                            if ((value.replace('.', '').length >= maxLength || decimalLength >= 2) && e.key !== 'Backspace' && e.key !== '.') {
                                                e.preventDefault(); 
                                            }
                                            if (decimalIndex === -1 && value.length >= 5 && e.key !== 'Backspace' && e.key !== '.') {
                                                e.preventDefault(); 
                                            }
                                        }}
                                        onChange={(e) =>{
                                                costWeightChange(e);
                                                setValue("shareQty",  e.target.value, { shouldValidate: true });
                                        }}
                                        onDrop={(e)=>e.preventDefault()}
                                        onPaste={(e)=>e.preventDefault()}
                                        autoComplete='off'
                                    />
                                    <DropdownButton
                                    variant="outline-secondary"
                                    title={units}
                                    id="input-group-dropdown-2"
                                    align="end"
                                    onSelect={(v) => {
                                        setUnits(v == 'qty' ? "Units":"Pounds");
                                        setValue("shareQtyUnit",v);
                                    }}
                                    >
                                    <Dropdown.Item eventKey='qty'>Units</Dropdown.Item>
                                    <Dropdown.Item eventKey='lbs'>Pounds</Dropdown.Item>
                                    </DropdownButton>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className='mt-2'>
                    {selectedLocation.includes("pickup") && (
                    fields.map((item, index) => {
                        return (
                        <Card key={item.id} className="mb-1">
                            <Card.Body>
                                <Row>
                                    <Col xs={6} md={5}>
                                        <Form.Group as={Col} controlId="formUserFirstName">
                                            <Form.Label className="smallTitle">Pickup Location <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                            <SelectDropdown
                                            id="addShareInfo"
                                                {...register(`pickupDetails.${index}.addressId`, { 
                                                    required: selectedLocation.includes("pickup") ? "Please select Address" : false 
                                                })}
                                                value={selectedAddress[index]}
                                                onChange={(v) => {
                                                    setSelectedAddress(current => {
                                                        current[index] = v;
                                                        return current;
                                                    });
                                                    setCurrentSelection({[index]:v});
                                                    setValue(`pickupDetails.${index}.addressId`, v.name,{ shouldValidate: true })
                                                    setValue(`pickupDetails.${index}.address`, v.values)
                                                }}
                                                options={addressList}
                                                isSearch={true}
                                                defaultValueProps={{
                                                    default: true,
                                                    defaultOption: {name:"",values:"-- Select --"},
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={6} md={5}>
                                        <Form.Group as={Col} controlId="formUserFirstName">
                                            <Form.Label className="smallTitle">Pickup Days<span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                            <SelectDropdown
                                                {...register(`pickupDetails.${index}.day`, { required: selectedLocation.includes("pickup") ? "Please select Day" : false })}
                                                value={selectedDay[index]}
                                                onChange={(v) => {
                                                    setSelectedDay(current => {
                                                        current[index] = v;
                                                        return current;
                                                    });
                                                    setCurrentSelection({[index]:v});
                                                    setValue(`pickupDetails.${index}.day`, v.name,{ shouldValidate: true })
                                                }}
                                                options={daysList}
                                                isSearch={true}
                                                defaultValueProps={{
                                                    default: true,
                                                    defaultOption: {name:"",values:"-- Select --"},
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} md={5}>
                                        <Form.Group as={Col} controlId="formUserFirstName">
                                            <Form.Label className="smallTitle">Opens <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                            <TimePickerViews 
                                                {...register(`pickupDetails.${index}.openTime`, { required: selectedLocation.includes("pickup") ? "Please select Opening Time" : false})}
                                                handleChange={(newValue) => {
                                                    setValue(`pickupDetails.${index}.openTime`,newValue.format("hh:mm A"),{ shouldValidate: true })
                                                }}
                                                value={moment(getValues(`pickupDetails.${index}.openTime`), "hh:mm A").format("YYYY-MM-DDTHH:mm")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={5}>
                                        <Form.Group as={Col} controlId="formUserFirstName">
                                            <Form.Label className="smallTitle">Closes <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                            <TimePickerViews 
                                                {...register(`pickupDetails.${index}.closeTime`, { required: selectedLocation.includes("pickup") ? "Please select Closing Time" : false })}
                                                handleChange={(newValue) => {
                                                    setValue(`pickupDetails.${index}.closeTime`,newValue.format("hh:mm A"),{ shouldValidate: true })
                                                }}
                                                value={moment(getValues(`pickupDetails.${index}.closeTime`), "hh:mm A").format("YYYY-MM-DDTHH:mm")}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={2}>
                                    <IconButton aria-label="ADD" onClick={() => append({ address: "", day: "", openTime: "12:00 AM", closeTime:"12:00 AM" })}>
                                        <AddIcon />
                                    </IconButton>
                                    { <IconButton aria-label="DELETE" onClick={() => {
                                            setSelectedDay(current => {
                                                current.splice(index, 1);
                                                return current;
                                            });
                                            setSelectedAddress(current => {
                                                current.splice(index, 1);
                                                return current;
                                            });
                                            remove(index)
                                            if (fields.length === 1) { 
                                                setDeletedPickupDetails(fields);
                                                setSelectedLocation(selectedLocation.filter(location => location !== "pickup"));
                                                setValue("location", selectedLocation.filter(location => location !== "pickup")); // Uncheck pickup location
                                            }
                                        }}>
                                        <DeleteIcon />
                                    </IconButton>}
                                    </Col>
                                </Row>
                            </Card.Body>
                            {selectedLocation.includes("pickup") && errors.pickupDetails?.[index] && <Card.Footer className="text-muted">
                                {Object.keys(errors.pickupDetails[index]).length > 0 && (
                                <Form.Text className="dh-txt-danger">
                                    <b><i className="fa fa fa-info-circle ml-2" aria-hidden="true"></i> Please select all fields in Pickup Details. </b>
                                </Form.Text> 
                                )}
                            </Card.Footer>}
                            {/* {errors.pickupDetails?.[index] && <Card.Footer className="text-muted">
                                {Object.entries(errors.pickupDetails[index]).some(([_, err]) => err?.message) && (
                                <Form.Text className="dh-txt-danger">
                                    <b><i className="fa fa fa-info-circle ml-2" aria-hidden="true"></i> Please select all fields in Pickup Details. </b>
                                </Form.Text> 
                                )}
                            </Card.Footer>} */}
                        </Card>
                        );
                    })
                    )}
                    </Row>
                    <Row>
                        {/* <Col>
                            <Form.Group as={Col} controlId="formUserDelivery">
                                <Form.Label className="smallTitle">Delivery Location <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                <Col key={`inline-radio`}>
                                    <Form.Check
                                        inline
                                        label="Yes"
                                        value="Y"
                                        {...register("dlvryFlg")}
                                        checked={deliveryLocation === "Y"}
                                        name="group1"
                                        type={'radio'}
                                        id={`inline-radio-1`}
                                        onChange={(e)=> setDeliveryLocation(e.target.value)}
                                        
                                    />
                                    <Form.Check
                                        inline
                                        label="No"
                                        value="N"
                                        {...register("dlvryFlg")}
                                        checked={deliveryLocation === "N"}
                                        name="group1"
                                        type={`radio`}
                                        id={`inline-radio-2`}
                                        onChange={(e)=> {
                                            setDeliveryLocation(e.target.value); clearErrors('range')
                                        }}
                                    />
                                 </Col>
                            </Form.Group>
                        </Col> */}

                    </Row>
                    {selectedLocation.includes("delivery") && <Row>
                        <Col>
                            <Form.Group as={Col}>
                                <Form.Label className="smallTitle">Delivery Range <span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                <Form.Control type="text" {...register("range", { validate: {
                                    required: (value) => (selectedLocation.includes("delivery") && value.length != 0) || "Please enter Delivery Range"
                                }})}
                                maxLength={100}
                                />
                            </Form.Group>
                        </Col>
                    </Row>}
                    {/* {deliveryLocation == "Y" && <Row>
                        <Col>
                            <Form.Group as={Col}>
                                <Form.Label className="smallTitle">Delivery Range<span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>
                                <Form.Control type="text" {...register("range", { validate: {
                                    required: (value) => (deliveryLocation == "Y" && value.length != 0) || "Please enter Delivery Range"
                                }})}
                                maxLength={100}
                                />
                            </Form.Group>
                        </Col>
                    </Row>} */}
                    <Form.Group as={Col} controlId="formDescription">
                        <Form.Label className="smallTitle">Share Description<span className="sr-only">required</span><span aria-hidden="true">*</span></Form.Label>     
                        {/* <Editor
                        editorStyle={{ height: '114px', border:'1px solid #E8E8E8' }}   // Text editor code for future use
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        onEditorStateChange={onEditorStateChange}
                        toolbar={
                            {
                                options: ['inline','fontSize', 'fontFamily', 'list', 'textAlign','link', 'history'],
                                inline: {
                                    options: ['bold', 'italic', 'underline'],
                                  },
                                fontFamily: {
                                    options: [
                                        'Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 
                                        'Verdana', 'Source Sans Pro', 'Courier New', 'Lucida Console', 
                                        'Monaco', 'Comic Sans MS', 'Trebuchet MS', 'Palatino Linotype', 
                                        'Gill Sans', 'Open Sans', 'Roboto', 'Lato', 'Montserrat'
                                      ],
                                },
                            }}
                        />
                        <input 
                            type="hidden"
                            {...register("dsc", { required: "Please enter Description"})}
                            value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                            /> */}
                        <Form.Control
                            type="hidden"
                            as="textarea"
                            placeholder=""
                            style={{ height: '114px' }} 
                            {...register("dsc", { required: "Please enter Description"})}
                            // maxLength={3000}
                            />
                        {/* <Form.Text id="formDescription" className="float-right" muted>
                            <i className="fa fa fa-info-circle ml-2" aria-hidden="true"></i> Max character: 3000
                        </Form.Text> */}
                    </Form.Group>
                </Col>
            </Row> 
            {onEdit && <Form.Control type="text" value={row.id} hidden />}
            <Row className="modal-footer">
                <Col>
                    <Button variant="primary" type="submit" className="float-right">
                        {onEdit ? 'Update':'Add'}
                    </Button>
                </Col>
            </Row>
        </Form>
    </div>
)
}
ShareAddEditComponent.propTypes = {
    validated: PropTypes.bool,
    submitShareData: PropTypes.func, 
    mapdata: PropTypes.object,
    onEdit: PropTypes.bool,
    row:PropTypes.object,
    getMyStoreDetails: PropTypes.func,
    vendorId:PropTypes.string,
    csaSignup: PropTypes.object.isRequired,
    getSnapCsaLocationList: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSnapCsaLocationList: (payload) =>dispatch(actionTypes.getSnapCsaLocationList(payload)),
    };
};


export default connect(mapStateToProps,mapDispatchToProps)(ShareAddEditComponent);